import { useContext } from 'react'
import { AuthContext } from '../AuthProvider'

export const useLogout = () => {
  const ctx = useContext(AuthContext)
  return ctx?.logout
}
